import { NotificationType, OrderStatus, Role } from "@enums";
import { Comment } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import { useCheckUserRole } from "@utils";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const CommentsIconButton = ({
  orderId,
  orderStatus,
  unreadCommentCount,
  setRowIsHovered,
}: {
  orderId: number;
  orderStatus?: string;
  unreadCommentCount: number;
  setRowIsHovered?: (hover: boolean) => void;
}) => {
  const navigate = useNavigate();
  const isRo = useCheckUserRole(Role.RO);

  const handleCommentClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();

      if (orderId === null || orderId === undefined) {
        return;
      }

      let path = `/order/${orderId}`;

      // This reuses the same navigation logic as notification.
      if (orderStatus && orderStatus !== OrderStatus.DRAFT) {
        if (isRo) {
          path = `/review/${orderId}`;
        } else {
          path = `/commandcenter/${orderId}/plan-review`;
        }
      }

      navigate(path, {
        state: {
          notificationType: NotificationType.NEW_COMMENT,
        },
      });
    },
    [navigate, isRo, orderId, orderStatus],
  );

  return (
    <IconButton
      color="secondary"
      size="small"
      data-testid={"comments-button"}
      onClick={handleCommentClick}
      onMouseEnter={() => setRowIsHovered?.(false)}
      onMouseLeave={() => setRowIsHovered?.(true)}
      sx={{ padding: 1 }}
    >
      <Badge badgeContent={unreadCommentCount} color="error">
        <Comment fontSize="small" />
      </Badge>
    </IconButton>
  );
};
export default CommentsIconButton;
